export default {"src":"/_next/static/media/audio.1a213ea1.svg","height":43,"width":46,"blurWidth":0,"blurHeight":0};